/* TX PDP gallery, rails, review lightbox, add-to-cart and sticky bar.
 * Class toggles only, no runtime node inserts: theme.liquid runs a document-wide Judge Me MutationObserver that thrashes on DOM churn. */
(function () {
  'use strict';

  /* TX 02/10/2026 (Jono): sticky top for the desktop gallery column, so a tall column is never cut off */
  function initStickyCol(root) {
    var col = root.querySelector('.tx-pdp__col');
    if (!col) return;
    var desk = window.matchMedia('(min-width: 990px)');
    var raf = 0;
    var last = '';

    /* header pins only after a little scroll, so always leave its height free */
    function headerBottom() {
      var h = document.querySelector('.page__header--desktop');
      return h ? h.offsetHeight : 0;
    }

    function place() {
      raf = 0;
      if (!desk.matches) { last = ''; col.style.removeProperty('--tx-col-top'); return; }
      var bar = document.querySelector('[data-tx-sticky-atc]');
      var room = window.innerHeight - (bar ? bar.offsetHeight : 0) - 16;
      var top = Math.round(Math.min(headerBottom() + 16, room - col.offsetHeight)) + 'px';
      if (top !== last) { last = top; col.style.setProperty('--tx-col-top', top); }
    }

    function queue() { if (!raf) raf = requestAnimationFrame(place); }
    window.addEventListener('resize', queue);
    if (desk.addEventListener) desk.addEventListener('change', queue);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(queue);
      ro.observe(col);
      var hdr = document.querySelector('.page__header--desktop');
      var sab = document.querySelector('[data-tx-sticky-atc]');
      if (hdr) ro.observe(hdr);
      if (sab) ro.observe(sab);
    }
    place();
  }

  function init(root) {
    if (root.dataset.txPdpReady === '1') return;
    root.dataset.txPdpReady = '1';
    initStickyCol(root);

    var shots = root.querySelectorAll('[data-tx-shot]');
    /* TX 29/09/2026: later shots arrive as data-tx-src so they don't compete with the first photo */
    function fill(el) {
      if (el && el.hasAttribute('data-tx-gvideo')) {
        var gv = el.querySelector('video');
        var gp = gv && gv.getAttribute('data-tx-poster');
        if (gp) { gv.poster = gp; gv.removeAttribute('data-tx-poster'); }
        return;
      }
      var s = el && el.getAttribute('data-tx-src');
      if (!s) return;
      var ss = el.getAttribute('data-tx-srcset');
      if (ss) { el.srcset = ss; el.removeAttribute('data-tx-srcset'); }
      el.src = s; el.removeAttribute('data-tx-src');
    }
    function fillAll() { for (var f = 0; f < shots.length; f++) fill(shots[f]); }
    /* TX 19/10/2026 (Hoe Ping): next photo after the first; the rest on gallery use or once the page has loaded. show() fills on demand */
    var firstShot = shots[0];
    var gallery = root.querySelector('[data-tx-gallery]') || root;
    function rest() { gallery.removeEventListener('pointerenter', rest); gallery.removeEventListener('touchstart', rest); gallery.removeEventListener('focusin', rest); fillAll(); }
    function kick() {
      fill(shots[1]);
      gallery.addEventListener('pointerenter', rest);
      gallery.addEventListener('touchstart', rest, { passive: true });
      gallery.addEventListener('focusin', rest);
      if (document.readyState === 'complete') setTimeout(rest, 1500);
      else window.addEventListener('load', function () { setTimeout(rest, 1500); });
    }
    if (!firstShot || firstShot.complete || firstShot.hasAttribute('data-tx-gvideo')) kick();
    else { firstShot.addEventListener('load', kick); firstShot.addEventListener('error', kick); }
    var zoom = root.querySelector('[data-tx-zoom]');
    var zoomBox = root.querySelector('[data-tx-zoom-box]');
    var large = zoomBox && zoomBox.querySelector('[data-tx-zoom-image]');
    if (zoom && zoomBox && large && typeof zoomBox.showModal === 'function') {
      var oldOverflow = '';
      /* TX 21/10/2026 (Jono): use real image dimensions, including asset galleries without Liquid metadata. */
      function zoomSize(width, height) {
        large.width = width > 0 && height > 0 ? width : 0;
        large.height = width > 0 && height > 0 ? height : 0;
      }
      large.addEventListener('load', function () { zoomSize(large.naturalWidth, large.naturalHeight); });
      zoom.addEventListener('click', function () {
        var active = root.querySelector('[data-tx-shot].is-active');
        if (!active) return;
        if (active.hasAttribute('data-tx-gvideo')) return;
        zoomSize(active.naturalWidth || Number(active.getAttribute('data-tx-zoom-width')),
          active.naturalHeight || Number(active.getAttribute('data-tx-zoom-height')));
        large.src = active.getAttribute('data-tx-zoom-src') || active.currentSrc || active.src;
        large.alt = active.alt;
        oldOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        zoomBox.showModal();
      });
      zoomBox.querySelector('[data-tx-zoom-close]').addEventListener('click', function () { zoomBox.close(); });
      zoomBox.addEventListener('click', function (e) { if (e.target === zoomBox) zoomBox.close(); });
      zoomBox.addEventListener('close', function () { document.body.style.overflow = oldOverflow; zoom.focus({ preventScroll: true }); });
    } else if (zoom) { zoom.hidden = true; }

    /* TX 19/10/2026 (Hoe Ping): gallery videos play muted while shown and on screen; the button pause sticks */
    var index = 0;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var stageOnScreen = !('IntersectionObserver' in window);
    function setVBtn(btn, paused) {
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', btn.getAttribute(paused ? 'data-tx-label-play' : 'data-tx-label-pause'));
    }
    function syncVideos() {
      for (var v = 0; v < shots.length; v++) {
        if (!shots[v].hasAttribute('data-tx-gvideo')) continue;
        var vid = shots[v].querySelector('video');
        var btn = shots[v].querySelector('[data-tx-vtoggle]');
        var stopped = shots[v].getAttribute('data-tx-vpaused') === '1' || (reduceMotion && shots[v].getAttribute('data-tx-vpaused') !== '0');
        if (v === index && stageOnScreen && !stopped) {
          if (!vid.getAttribute('src')) vid.src = vid.getAttribute('data-tx-vsrc');
          var pr = vid.play();
          if (btn) setVBtn(btn, false);
          if (pr && pr.catch) (function (b) { pr.catch(function () { if (b) setVBtn(b, true); }); })(btn);
        } else {
          vid.pause();
          if (btn) setVBtn(btn, true);
        }
      }
    }
    var vBtns = root.querySelectorAll('[data-tx-vtoggle]');
    for (var vb = 0; vb < vBtns.length; vb++) {
      vBtns[vb].addEventListener('click', function () {
        var wrap = this.closest('[data-tx-gvideo]');
        var vEl = wrap.querySelector('video');
        wrap.setAttribute('data-tx-vpaused', vEl.paused ? '0' : '1');
        syncVideos();
      });
    }
    if (vBtns.length && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { stageOnScreen = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25; syncVideos(); }, { threshold: [0, 0.25] }).observe(root.querySelector('[data-tx-stage]'));
    } else if (vBtns.length) { syncVideos(); }

    if (shots.length < 2) return;

    var thumbs = root.querySelectorAll('[data-tx-thumb]');
    var dots = root.querySelectorAll('[data-tx-dot]');
    var prev = root.querySelector('[data-tx-prev]');
    var next = root.querySelector('[data-tx-next]');

    function show(i) {
      var n = shots.length;
      index = ((i % n) + n) % n;
      fill(shots[index]);
      fill(shots[(index + 1) % n]);

      for (var s = 0; s < shots.length; s++) {
        shots[s].classList.toggle('is-active', s === index);
      }
      for (var t = 0; t < thumbs.length; t++) {
        thumbs[t].setAttribute('aria-current', t === index ? 'true' : 'false');
      }
      /* Keep one preceding thumbnail visible without scrolling the page. */
      if (thumbs[index] && thumbs[index].closest('.tx-pdp__thumbs')) {
        var strip = thumbs[index].closest('.tx-pdp__thumbs');
        var previous = thumbs[Math.max(0, index - 1)];
        var target = previous.getBoundingClientRect().left - strip.getBoundingClientRect().left + strip.scrollLeft;
        strip.scrollLeft = Math.max(0, Math.min(target, strip.scrollWidth - strip.clientWidth));
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === index);
      }
      /* TX 21/08/2026 (Jono): stat badges overlay image 1 only */
      root.classList.toggle('tx-pdp--slid', index > 0);
      syncVideos();
    }

    for (var t = 0; t < thumbs.length; t++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          show(parseInt(btn.getAttribute('data-tx-thumb'), 10) || 0);
        });
      })(thumbs[t]);
    }

    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });

    root.querySelector('.tx-pdp__stagewrap').addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(index - 1); }
      else if (e.key === 'ArrowRight') { show(index + 1); }
    });
  }

  /* Rail dots: class toggle only. data-tx-bc-* and data-tx-rail* are both matched; use one set per section, never both on one element. */
  var RAIL_SEL = '[data-tx-bc-rail],[data-tx-rail]';
  var RAIL_ITEM_SEL = '[data-tx-bc-card],[data-tx-rail-item]';
  var RAIL_DOT_SEL = '[data-tx-bc-dot],[data-tx-rail-dot]';

  function initRail(rail) {
    if (rail.dataset.txRailReady === '1') return;
    rail.dataset.txRailReady = '1';

    var dots = rail.parentNode.querySelectorAll(RAIL_DOT_SEL);
    var cards = rail.querySelectorAll(RAIL_ITEM_SEL);
    if (!dots.length || cards.length < 2) return;

    var ticking = false;

    function sync() {
      ticking = false;
      // pitch from the live boxes: card width is a flex division
      var pitch = cards[1].offsetLeft - cards[0].offsetLeft;
      if (pitch <= 0) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var i;
      // the last cards never reach the start position, so snap to the end index once scrolled out
      if (max > 0 && max - rail.scrollLeft < 2) {
        i = dots.length - 1;
      } else {
        i = Math.round(rail.scrollLeft / pitch);
      }
      if (i < 0) i = 0;
      if (i > dots.length - 1) i = dots.length - 1;
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === i);
      }
    }

    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(sync);
    }, { passive: true });

    sync();
  }

  /* Review lightbox, filled from the card's own DOM so it can't drift. Writes the DOM once per click; never move these writes to scroll or hover. */
  function initReviewLightbox(root) {
    if (root.dataset.txRvLbReady === '1') return;

    var box = root.querySelector('[data-tx-rv-lightbox]');
    if (!box || typeof box.showModal !== 'function') return;
    /* TX 21/09/2026: claim the root only once the dialog exists, or an early call disables it for good */
    root.dataset.txRvLbReady = '1';

    var photo = box.querySelector('[data-tx-rv-lb-photo]');
    var stars = box.querySelector('[data-tx-rv-lb-stars]');
    var title = box.querySelector('[data-tx-rv-lb-title]');
    var quote = box.querySelector('[data-tx-rv-lb-quote]');
    var who = box.querySelector('[data-tx-rv-lb-who]');
    var prevBtn = box.querySelector('[data-tx-rv-lb-prev]');
    var nextBtn = box.querySelector('[data-tx-rv-lb-next]');
    var countEl = box.querySelector('[data-tx-rv-lb-count]');
    var opener = null;
    /* TX 21/09/2026: photo paging, a Judge Me review can carry several photos */
    var shots = [];
    var at = 0;

    function paint() {
      var shot = shots[at];
      if (!shot) return;
      var im = shot.querySelector('img');
      photo.src = shot.getAttribute('data-photo') || (im ? im.src : '');
      photo.alt = im ? im.alt : '';
      var many = shots.length > 1;
      if (prevBtn) prevBtn.hidden = !many;
      if (nextBtn) nextBtn.hidden = !many;
      if (countEl) {
        countEl.hidden = !many;
        countEl.textContent = (at + 1) + ' / ' + shots.length;
      }
    }

    function step(by) {
      if (shots.length < 2) return;
      at = (at + by + shots.length) % shots.length;
      paint();
    }

    function open(trigger) {
      var card = trigger.closest('.tx-rv__card');
      if (!card) return;

      shots = Array.prototype.slice.call(card.querySelectorAll('[data-tx-rv-open]'));
      if (shots.indexOf(trigger) === -1) shots = [trigger];
      at = Math.max(0, shots.indexOf(trigger));
      paint();

      var s = card.querySelector('.tx-rv__stars');
      var t = card.querySelector('.tx-rv__title');
      var q = card.querySelector('.tx-rv__quote');
      var w = card.querySelector('.tx-rv__who');
      stars.textContent = s ? s.textContent : '';
      // Keep merchant formatting when opening the full review.
      title.replaceChildren();
      quote.replaceChildren();
      if (t) Array.from(t.childNodes).forEach(function (node) { title.appendChild(node.cloneNode(true)); });
      if (q) Array.from(q.childNodes).forEach(function (node) { quote.appendChild(node.cloneNode(true)); });
      box.dataset.txRichtextBuild = '20260909-r1';
      who.innerHTML = '';
      if (w) who.appendChild(w.cloneNode(true));

      opener = trigger;
      document.body.style.overflow = 'hidden';
      box.showModal();
    }

    /* TX 21/09/2026: this dialog doesn't fire close on the PDP, so release body overflow on every close path */
    function release() {
      document.body.style.overflow = '';
      if (opener) opener.focus();
    }
    function shut() {
      box.close();
      release();
    }

    box.addEventListener('close', release);
    box.addEventListener('cancel', release);
    // the dialog element itself is the scrim; panel clicks land on children
    box.addEventListener('click', function (e) {
      if (e.target === box) shut();
    });
    box.querySelector('[data-tx-rv-lb-close]').addEventListener('click', shut);
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); step(1); });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });

    root.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest ? e.target.closest('[data-tx-rv-open]') : null;
      if (!trigger) return;
      e.preventDefault();
      open(trigger);
    });
  }

  /* AJAX add-to-cart: Unicorn Boost opens its drawer by observing window.fetch, so a native POST just reloads. Must stay window.fetch, not XHR; never open the drawer ourselves. */
  function initAddToCart(form) {
    if (form.dataset.txAtcReady === '1') return;
    form.dataset.txAtcReady = '1';

    // closure flag, not a DOM write, so the Judge Me observer isn't fed
    var busy = false;

    form.addEventListener('submit', function (e) {
      if (busy) { e.preventDefault(); return; }
      var btn = form.querySelector('.tx-pdp__atc');
      if (btn && btn.disabled) return;

      e.preventDefault();
      busy = true;
      var accepted = false;

      window.fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      }).then(function (res) {
        if (!res.ok) throw new Error('cart/add ' + res.status);
        accepted = true;
        return res.json();
      }).then(function () {
        busy = false;
        // Unicorn's fetch observer opens the drawer
      }).catch(function () {
        // 422/429 are live here: fall back to the real submit so the button never dies
        // TX 02/10/2026: once Shopify has accepted the add, never resubmit (double add); show the cart
        busy = false;
        if (accepted) { window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart'; return; }
        HTMLFormElement.prototype.submit.call(form);
      });
    });
  }

  /* Sticky buy bar: the sentinel is the real ATC button; the 8px dead-band stops flicker on momentum scroll */
  function initSticky(bar) {
    if (bar.dataset.txStickyReady === '1') return;
    bar.dataset.txStickyReady = '1';

    var sentinel = document.querySelector('#tx-pdp-form .tx-pdp__atc');
    if (!sentinel) return;

    /* TX 21/10/2026 (Tack): mirror Easy Bundle's selection; its button owns bundle items and discounts. */
    var purchase = document.querySelector('[data-tx-pdp]');
    var title = bar.querySelector('.tx-sa__title');
    var price = bar.querySelector('.tx-sa__price');
    var was = bar.querySelector('.tx-sa__was');
    var add = bar.querySelector('[data-tx-sticky-add]');
    var baseline = null;
    var bundleFrame = 0;
    function setText(node, value) {
      if (node && node.textContent !== value) node.textContent = value;
    }
    function restoreBundle() {
      if (!baseline) return;
      setText(title, baseline.title);
      setText(price, baseline.price);
      if (was) was.hidden = baseline.wasHidden;
      if (add) add.disabled = baseline.disabled;
      bar.classList.remove('tx-sa--bundle');
      baseline = null;
    }
    function bundle() {
      var root = purchase && purchase.querySelector('#my-custom-bundle');
      return root && root.getClientRects().length ? root : null;
    }
    /* TX 22/10/2026 (Jono): Easy Bundle can show $0 tiers after a country change; until all tiers are priced, keep the normal sticky on screen. */
    function pricedBundle() {
      var root = bundle();
      var tiers = root ? root.querySelectorAll('.bundle__tier') : [];
      if (!tiers.length || !root.querySelector('.bundle__tier.is-selected')) return null;
      for (var i = 0; i < tiers.length; i++) {
        var amount = tiers[i].querySelector('.bundle__tier-price-current');
        if (!amount || !/[1-9]/.test(amount.textContent)) return null;
      }
      return root;
    }
    function syncBundle() {
      bundleFrame = 0;
      var root = pricedBundle();
      if (!root) { restoreBundle(); sync(); return; }
      if (!baseline) {
        baseline = { title: title && title.textContent, price: price && price.textContent, disabled: add && add.disabled, wasHidden: was && was.hidden };
        bar.classList.add('tx-sa--bundle');
      }
      var selected = root.querySelector('.bundle__tier.is-selected');
      var button = root.querySelector('.bundle__atc-btn');
      var name = selected && selected.querySelector('.bundle__tier-title');
      var amount = selected && selected.querySelector('.bundle__tier-price-current');
      setText(title, name ? name.textContent.trim() : baseline.title);
      setText(price, amount ? amount.textContent.trim() : baseline.price);
      if (was) was.hidden = true;
      var disabled = !selected || !button || button.disabled || button.getAttribute('aria-disabled') === 'true';
      if (add && add.disabled !== disabled) add.disabled = disabled;
      sync();
    }
    function queueBundle() {
      if (!bundleFrame) bundleFrame = window.requestAnimationFrame(syncBundle);
    }
    if (purchase) {
      var bundleObserver = new MutationObserver(queueBundle);
      bundleObserver.observe(purchase.querySelector('.tx-pdp__offer') || purchase, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled', 'style'] });
      var cleanupBundle = function (event) {
        if (!event.target.contains(bar) && !event.target.contains(purchase)) return;
        bundleObserver.disconnect();
        if (bundleFrame) window.cancelAnimationFrame(bundleFrame);
        restoreBundle();
        window.removeEventListener('resize', resizeSticky);
        window.removeEventListener('scroll', scrollSticky);
        bar.removeEventListener('click', clickSticky);
        document.removeEventListener('shopify:section:unload', cleanupBundle);
        delete bar.dataset.txStickyReady;
      };
      document.addEventListener('shopify:section:unload', cleanupBundle);
    }
    var ticking = false;
    var shown = bar.classList.contains('is-shown');
    syncBundle();

    /* TX 24/09/2026 (Jono): show whenever the real button is off screen, above or below */
    function sync() {
      ticking = false;
      var root = bundle();
      if (root && !pricedBundle()) {
        if (!shown) { shown = true; bar.classList.add('is-shown'); }
        return;
      }
      var activeSentinel = (root && root.querySelector('.bundle__atc-btn')) || sentinel;
      var r = activeSentinel.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var offAbove = r.bottom < -8, offBelow = r.top > vh + 8;
      var onScreen = r.bottom > 8 && r.top < vh - 8;
      if (!shown && (offAbove || offBelow)) {
        shown = true;
        bar.classList.add('is-shown');
      } else if (shown && onScreen) {
        shown = false;
        bar.classList.remove('is-shown');
      }
    }
    function resizeSticky() { window.requestAnimationFrame(sync); }
    window.addEventListener('resize', resizeSticky, { passive: true });

    function scrollSticky() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(sync);
    }
    window.addEventListener('scroll', scrollSticky, { passive: true });

    /* click the real ATC: Unicorn Boost binds a descendant selector inside the form, so the outside button would reload the page */
    function clickSticky(e) {
      var trigger = e.target && e.target.closest ? e.target.closest('[data-tx-sticky-add]') : null;
      if (!trigger || trigger.disabled) return;
      var root = pricedBundle();
      if (root) {
        e.preventDefault();
        var bundleAdd = root.querySelector('.bundle__atc-btn');
        if (root.querySelector('.bundle__tier.is-selected') && bundleAdd && !bundleAdd.disabled && bundleAdd.getAttribute('aria-disabled') !== 'true') bundleAdd.click();
        return;
      }
      var real = document.querySelector('#tx-pdp-form .tx-pdp__atc');
      if (!real) return;
      e.preventDefault();
      if (!real.disabled) real.click();
    }
    bar.addEventListener('click', clickSticky);

    sync();
  }

  var TX_PDP_BUILD = '20260909-r3';

  /* keep the observer held in a variable: an unreferenced observer has broken this theme twice */
  function initAutoSlide(rail) {
    if (rail.dataset.txAutoReady === '1') return;
    rail.dataset.txAutoReady = '1';
    var ms = parseInt(rail.getAttribute('data-tx-autoslide'), 10);
    if (!ms || ms < 1000) return;
    var items = rail.querySelectorAll(RAIL_ITEM_SEL);
    if (items.length < 2) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var hover = false;
    var inView = true;
    var lastTouch = 0;
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
      });
      io.observe(rail);
    }
    rail.addEventListener('mouseenter', function () { hover = true; });
    rail.addEventListener('mouseleave', function () { hover = false; });
    rail.addEventListener('pointerdown', function () { lastTouch = Date.now(); });
    setInterval(function () {
      if (hover || !inView || document.hidden || reduced.matches) return;
      if (rail.classList.contains('is-dragging')) return;
      if (Date.now() - lastTouch < 8000) return;
      var pitch = items[1].offsetLeft - items[0].offsetLeft;
      if (pitch <= 0) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var next = (Math.round(rail.scrollLeft / pitch) + 1) * pitch;
      if (next > max + 2) next = 0;
      rail.scrollTo({ left: next, behavior: 'smooth' });
    }, ms);
  }
  /* mouse only; snaps by hand on release because is-dragging disables CSS snap */
  function initDrag(rail) {
    if (rail.dataset.txDragReady === '1') return;
    rail.dataset.txDragReady = '1';

    var active = false, moved = false, startX = 0, startLeft = 0, pid = null, lastDx = 0;

    /* TX 24/09/2026 (Jono): suppress text/image drag; a flick past 40px moves a card */
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest && e.target.closest('a, button')) return;
      e.preventDefault();
      active = true; moved = false; lastDx = 0;
      startX = e.clientX; startLeft = rail.scrollLeft; pid = e.pointerId;
    });

    rail.addEventListener('pointermove', function (e) {
      if (!active || e.pointerId !== pid) return;
      var dx = e.clientX - startX;
      lastDx = dx;
      if (!moved && Math.abs(dx) > 3) {
        moved = true;
        rail.classList.add('is-dragging');
        try { rail.setPointerCapture(pid); } catch (err) { /* no-op */ }
      }
      if (moved) rail.scrollLeft = startLeft - dx;
    });

    function end() {
      if (!active) return;
      active = false;
      rail.classList.remove('is-dragging');
      if (!moved) return;
      var items = rail.querySelectorAll(RAIL_ITEM_SEL);
      if (items.length > 1) {
        var pitch = items[1].offsetLeft - items[0].offsetLeft;
        if (pitch > 0) {
          var from = Math.round(startLeft / pitch);
          var idx = Math.abs(lastDx) > 40 ? from + (lastDx < 0 ? 1 : -1) : Math.round(rail.scrollLeft / pitch);
          idx = Math.max(0, Math.min(items.length - 1, idx));
          rail.scrollTo({ left: idx * pitch, behavior: 'smooth' });
        }
      }
    }
    rail.addEventListener('pointerup', end);
    rail.addEventListener('pointercancel', end);
  }

  /* TX 16/10/2026 (Jono): sticky and final CTA labels follow the buy box button, so a market override can't leave them saying something else */
  function syncAtcLabels() {
    var src = document.querySelector('#tx-pdp-form .tx-pdp__atc strong');
    if (!src) return;
    var html = src.innerHTML.trim();
    if (!html) return;
    var targets = document.querySelectorAll('[data-tx-atc-label]');
    for (var i = 0; i < targets.length; i++) targets[i].innerHTML = html;
  }

  function boot() {
    syncAtcLabels();
    var roots = document.querySelectorAll('[data-tx-pdp]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);

    var rails = document.querySelectorAll(RAIL_SEL);
    for (var r = 0; r < rails.length; r++) initRail(rails[r]);

    var dragRails = document.querySelectorAll('[data-tx-drag]');
    for (var g = 0; g < dragRails.length; g++) initDrag(dragRails[g]);

    var autoRails = document.querySelectorAll('[data-tx-autoslide]');
    for (var a = 0; a < autoRails.length; a++) initAutoSlide(autoRails[a]);

    var bars = document.querySelectorAll('[data-tx-sticky-atc]');
    for (var s = 0; s < bars.length; s++) initSticky(bars[s]);

    var forms = document.querySelectorAll('#tx-pdp-form');
    for (var c = 0; c < forms.length; c++) initAddToCart(forms[c]);

    var rvs = document.querySelectorAll('.tx-rv');
    for (var v = 0; v < rvs.length; v++) initReviewLightbox(rvs[v]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // theme editor re-renders the section without a page load
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-tx-pdp]');
    if (root) init(root);
    syncAtcLabels();
    var editorBars = document.querySelectorAll('[data-tx-sticky-atc]');
    for (var eb = 0; eb < editorBars.length; eb++) initSticky(editorBars[eb]);
    var editorRails = e.target.querySelectorAll(RAIL_SEL);
    for (var er = 0; er < editorRails.length; er++) initRail(editorRails[er]);
    var editorDrags = e.target.querySelectorAll('[data-tx-drag]');
    for (var eg = 0; eg < editorDrags.length; eg++) initDrag(editorDrags[eg]);
  });
})();
